import React, { useContext } from 'react';
import './PerfVsIndexCapsuleValues.scss';
import AppContext from 'app/AppContext';
import { PerfVsIndexData } from 'widgets/perfVsIndexCapsule/perfVsIndexCapsuleData';
import { getItemTimeOrLastItem } from 'utils/timeseries/timeSeriesUtils';
import { getActualValue } from 'utils/interpolation';

export interface PefVsIndexCapsuleValuesProps {
    data: PerfVsIndexData;
    time?: number;
    index: string;
    onClick: () => void;
}

export function PerfVsIndexCapsuleValues(props: PefVsIndexCapsuleValuesProps) {
    const {
        onClick,
        time,
        data: { timeSeries, lastNotNilItem },
        index,
    } = props;

    const { numberFormat, timeFormat } = useContext(AppContext);

    let item = lastNotNilItem;

    if (time !== undefined) {
        const timeItem = getItemTimeOrLastItem(timeSeries, time);
        if (timeItem) {
            item = timeItem;
        }
    }

    if (!item) {
        return <div className="PerfVsIndexCapsuleValues" />;
    }

    const timeDisplay = timeFormat.toTimeMinutes(item.time);
    const relativePerfOrderToIndex = numberFormat.n4(
        getActualValue(item.relativePerfOrderToIndex)
    );
    const relativePerfIndex = numberFormat.n4(
        getActualValue(item.relativePerfIndex)
    );

    const label = index.startsWith('.') ? 'Perf vs' : 'Perf vs.';

    return (
        <div className="PerfVsIndexCapsuleValues flippable" onClick={onClick}>
            <div className="time">{timeDisplay}</div>
            <div className="capsule-values">
                <div>
                    <div className="label">
                        {label} {index}
                    </div>
                    <div className="value high-value">
                        {relativePerfOrderToIndex}%
                    </div>
                </div>
            </div>
            <div className="capsule-values">
                <div>
                    <div className="label">{index}</div>
                    <div className="value low-value">{relativePerfIndex}%</div>
                </div>
            </div>
        </div>
    );
}
